import React, { useEffect, useState } from "react";

import * as Yup from "yup";

import { axiosInstance } from "../../utils/axios-instance";

import { Formik, Form } from "formik";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

// import { selectSignIn } from "../../store/slices/signed-in-slice";
// import { fetchSignIn } from "../../store/thunks/fetch-sign-in-thunk";
import { fetchEmail2faVerified } from '../../store/thunks/fetch-email-2fa-verified-thunk'

import { selectEmail2faData } from "../../store/slices/email-2fa-verified-slice";
import { selectEmail2faStatus } from "../../store/slices/email-2fa-verified-slice";

import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";

import { IoShieldCheckmarkSharp } from "react-icons/io5";
import { ImCross } from "react-icons/im";

import { Button, Row, Col, Spinner, Container } from "react-bootstrap";

import { SecuritySettingSubmission } from "./Security-Settings-Submission";

import {toast} from 'react-toastify';

export const SecuritySettings = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const isSignedIn = useSelector(selectSignIn);
    const email2faData = useSelector(selectEmail2faData)
    const email2faStatus = useSelector(selectEmail2faStatus)
    const [passwordChangesubmitted, setPasswordChangeSubmitted] = useState(false)

    // 429, too many requests error for password changes
    const [is429PasswordChangeError, setIs429PasswordChangeError] = useState(false);
    const [timeLeftPasswordReset, setTimeLeftPasswordReset] = useState(0);


    // 429, too many requests error for 2fa
    const [is4292faVerificationError, setIs4292faVerificationError] = useState(false);
    const [timeLeft2faVerification, setTimeLeft2faVerification] = useState(0);

    // States for sending password link 
    const [resetErr, setResetErr] = useState(false)
    const [success, setSuccess] = useState(false)
    const [loading, setLoading] = useState(false)

    // State for showing the 2FA 
    const [show2faInput, setShow2faInput] = useState(!email2faStatus)

    const ToastID = React.useRef(null)

    let response2faRequest

    // 429, too many requests error for 2fa verification

    let Email2faValidation = Yup.object({
        email2fa: Yup.string()
            .email("Invalid Email Address")
            .max(155, "Email is too long. 155 Characters Max")
            .required("A Valid Email is Required"),
    })
    // // If user is NOT signed in,
    // // redirect to the home page
    // useEffect(() => {
    //     
    //     // if (isSignedIn === false) {
    //     //     navigate("/");
    //     // }
    // }, [dispatch, isSignedIn, navigate]);

    useEffect(() => {
        async function fetchData() {
            await dispatch(fetchEmail2faVerified())
        }
        fetchData()

    }, [dispatch])

    // Password reset timer
    useEffect(() => {
        if (timeLeftPasswordReset <= 0 && is429PasswordChangeError) {
            setIs429PasswordChangeError(false);
            setPasswordChangeSubmitted(false)
        }

        if (timeLeftPasswordReset <= 0) {
            return;
        }

        const myInterval = setInterval(() => {
            setTimeLeftPasswordReset((t) => t - 1);
            return () => clearInterval(myInterval);
        }, 1000);
        return () => clearInterval(myInterval);
    }, [timeLeftPasswordReset, is429PasswordChangeError]);

    // 2fa verification reset timer
    useEffect(() => {
        if (timeLeft2faVerification <= 0 && is4292faVerificationError) {
            setIs4292faVerificationError(false);
            setPasswordChangeSubmitted(false)
        }

        if (timeLeft2faVerification <= 0) {
            return;
        }

        const myInterval = setInterval(() => {
            setTimeLeft2faVerification((t) => t - 1);
            return () => clearInterval(myInterval);
        }, 1000);
        return () => clearInterval(myInterval);
    }, [timeLeft2faVerification, is4292faVerificationError]);

    let resetPasswordContent = <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
    </Spinner>

    return (
        <>
            <Container className="bg-body-secondary rounded-3 justify-content-center my-4 py-4">
                <Row className="my-2 py-2">
                    <Row>
                        <h1 className="opacity-75 border-bottom border-warning border-2 title-font">Advanced Settings:</h1>
                    </Row>
                </Row>
                <Row className="my-4 card-background ">
                        <h2>Reset Password?</h2>
                    <Row className="card-font mb-3">

                        {!passwordChangesubmitted && (
                            <Col className="d-flex justify-content-start">
                                <Button
                                    className="btn btn-success btn-lg"
                                    onClick={
                                        async () => {
                                            ToastID.current = toast.loading(`Attempting to Send Reset Password Link`, {theme: "colored", containerId:"root", autoClose: "5000"} )
                                            setPasswordChangeSubmitted(true)
                                            setLoading(true)

                                            try {
                                                await axiosInstance({
                                                    method: "post",
                                                    url: "/change-password",
                                                    headers: {
                                                        "Content-Type": "application/json",
                                                    },
                                                })

                                                setLoading(false)
                                                setSuccess(true)
                                                toast.update(ToastID.current , {render: `Successfully Sent Reset Password Link. Please Check Your Email`, type: "success", isLoading: false, theme: "colored", autoClose: "3500",  containerId:"root"} )
                                            } catch (err) {
                                                setPasswordChangeSubmitted(true)
                                                setLoading(false)
                                                setResetErr(true)
                                                toast.update(ToastID.current , {render: `Failed to Send Reset Password Link. Please Try Again Later`, type: "error", isLoading: false, theme: "colored", autoClose: "5000", containerId:"root"})

                                                const errCode = err?.request?.status;
                                                // If 429, too many requests then set the 429 error and time left
                                                if (errCode === 429) {
                                                    setTimeLeftPasswordReset(
                                                        err?.response?.data &&
                                                        Number(err?.response?.data),
                                                    );

                                                    setIs429PasswordChangeError(true);
                                                }
                                                // return Promise.reject(err);
                                            }
                                        }
                                    }>
                                    Send Password Reset Link
                                </Button>
                            </Col>
                        )
                        }


                        <Row>
                            <Col className="d-flex justify-content-center">
                                {loading && resetPasswordContent}
                            </Col>
                        </Row>

                        {passwordChangesubmitted && resetErr && !is429PasswordChangeError && (<p role="status" className="text-danger">Error sending password reset link</p>)}
                        {passwordChangesubmitted && success && (<p role="status" className="text-success">
                            Sent a password change link to the email associated with this account
                        </p>)}
                        {is429PasswordChangeError && (
                            <p role="status" className="text-danger">
                                Too Many Reset Password Change Links Sent, Retry after{" "}
                                {Math.floor(timeLeftPasswordReset / 60 / 60)} Hours(s) and {Math.floor(timeLeftPasswordReset / 60 % 60)} Minutes{" "}
                            </p>
                        )}
                    </Row>


                </Row>
                {/* <Row className="bg-body-secondary rounded-3 justify-content-center my-4 py-4">    
                <Row className="card-background mt-3 mb-3">
                    <h3>
                        Two-Factor authentication Status:
                    </h3>
                </Row>

                <Row>
                    { email2faData.isVerified === false && <h4 className="text-danger"><ImCross />&nbsp; No 2-Factor Authentication</h4>}
                    <Col className="d-flex justify-content-start ">
                        {email2faStatus === "loading" && (<Spinner className="" animation="border" role="status"></Spinner>)}
                    </Col>
                    { email2faData.isVerified === true && <h4 className="text-success"><IoShieldCheckmarkSharp />&nbsp;2-Factor Authentication Enabled:<br />{email2faData.email2fa}</h4>}
                </Row>
                
                {!show2faInput && (
                    <Row className="mt-3">
                        <Col>
                            <Button onClick={() => setShow2faInput(!show2faInput)}>{!show2faInput ? "Update 2FA Email" : "Cancel?" }</Button>
                        </Col>
                    </Row>
                )}

                {show2faInput && (
                    <>
                        <Row className="card-background mt-4">
                            <h2>
                                Update Two-factor Authentication (2FA) Email?
                            </h2>
                        </Row>
                        <Row className="card-font">
                            <Formik 
                                initialValues={{
                                    email2fa: ""
                                }}
                                validationSchema={Email2faValidation}
                                onSubmit={async (values, {setStatus}) => {
                                    try {
                                        response2faRequest = await axiosInstance({
                                            method: "post",
                                                url: "/request-verify-phone",
                                                headers: {
                                                    "Content-Type": "application/json"
                                                },
                                                data: {
                                                    email2fa: values.email2fa
                                                }
                                        })

                                        // If successful sign-in but the user does not have a verified phone
                                        // Generate a code and redirect to unique page to verify it
                                        if(response2faRequest?.data.status === 0 && response2faRequest?.data.message === "Error phone") {
                                            navigate(
                                                `/verify-phone?client_id=${response2faRequest.data.data}&type=security-settings`
                                            );
                                            return Promise.reject();
                                        }
                                        } catch (err) {

                                        const errCode = err?.request?.status;
                                        setStatus({ error: true });
                                        // If 429, too many requests then set the 429 error and time left
                                        if (errCode === 429) {
                                            setTimeLeft2faVerification(
                                                err?.response?.data &&
                                                    Number(err?.response?.data),
                                            );
                                            setIs4292faVerificationError(true)
                                        } 
                                        console.error(err)
                                    }

                            }}>
                                <Form>
                                    <Row className="mb-2">
                                        <Col>
                                            <GeneralTextAreaField
                                                label="Email:"
                                                className="form-control"
                                                component="input"
                                                name="email2fa"
                                                rows="1"
                                                placeholder="Enter Valid Email"
                                            />
                                        </Col>
                                        
                                    </Row>
                                    <Row>
                                        <Col>
                                            <SecuritySettingSubmission props ={{ show2faInput, setShow2faInput }} />
                                        </Col>
                                    </Row>
                                </Form>
                            </Formik>
                            {is4292faVerificationError && (
                                        <p className="text-danger">
                                            Too Many Reset 2FA Verification codes Sent, Retry after{" "}
                                            {Math.floor(timeLeft2faVerification / 60 / 60)} Hours(s) and {Math.floor(timeLeft2faVerification / 60 % 60)} Minutes{" "}
                                        </p>
                                    )}
                        </Row>
                    </>
                )}
            </Row> */}
            </Container>
        </>
    );
}